import { render } from "./PatientDataSharingRequest.vue?vue&type=template&id=b89d070a"
import script from "./PatientDataSharingRequest.vue?vue&type=script&lang=js"
export * from "./PatientDataSharingRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__